import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) this.props.onReset();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white border border-red-200 rounded-3xl p-8 text-center space-y-4 shadow-lg my-6 max-w-lg mx-auto">
          <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto">
            <AlertTriangle className="w-8 h-8" />
          </div>
          <h3 className="text-xl font-black text-[var(--c-navy)]">حدث خطأ أثناء عرض الصفحة</h3>
          <p className="text-xs text-[var(--c-muted)] leading-relaxed">
            حدث خطأ غير متوقع في واجهة هذه الصفحة. تم حفظ كافة بياناتك وحسابك المالي بأمان.
          </p>
          <div className="flex gap-3 justify-center pt-2">
            <button
              onClick={this.handleReset}
              className="px-5 py-2.5 bg-[var(--c-navy)] text-white rounded-xl text-xs font-bold flex items-center gap-2 hover:bg-[#152943] transition"
            >
              <RefreshCw className="w-4 h-4" />
              <span>إعادة محاولة التحميل</span>
            </button>
            <button
              onClick={() => window.location.href = "/"}
              className="px-4 py-2.5 border border-slate-300 text-[var(--c-navy)] rounded-xl text-xs font-bold flex items-center gap-2 hover:bg-slate-50 transition"
            >
              <Home className="w-4 h-4" />
              <span>الرئيسية</span>
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
